import FJPool from './FJPool';

class FJPoolImage extends FJPool {
    _clearItem(value) {
        // 传入的 value（Image）需要在外界解绑所有事件
        value.src = '';
    }

    _createItem() {
        return { value: new Image(), idle: true };
    }
}

export default FJPoolImage;
